import React, {Component} from "react";
import {Helmet} from "react-helmet";
import TopMenu from "../components/TopMenu";
import ItemDataDetail from "../components/Data/ItemDataDetail";
import UserDataDetail from "../components/Data/UserDataDetail";
import EventDataDetail from "../components/Data/EventDataDetail";
import {createTheme, ThemeProvider} from "@mui/material";

class Data extends Component {
    constructor(props) {
        super(props);

        this.state = {
            active: "items"
        };
        this.setActive = this.setActive.bind(this);
    }

    setActive(value) {
        this.setState({
            active: value
        });
    }

    render() {
        const types = [
            {name: "Items", value: "items"},
            {name: "Users", value: "users"},
            {name: "Events", value: "events"}];

        const theme = createTheme({
            palette: {
                primary: {
                    main: '#86BC25FF',
                },
            },
        });

        return (
            <div className="data-page">
                <Helmet>
                    <title>Data</title>
                </Helmet>
                <TopMenu/>
                <div className="tab-group">
                    {types.map((type) => (
                        <button className={"data-tab" + (this.state.active === type.value ? " active" : "")}
                                key={type.value}
                                onClick={() => this.setActive(type.value)}>
                            {type.name}
                        </button>
                    ))}
                </div>
                <ThemeProvider theme={theme}>
                    {this.state.active === "items" && (
                        <ItemDataDetail/>)
                    }
                    {this.state.active === "users" && (
                        <UserDataDetail/>)
                    }
                    {this.state.active === "events" && (
                        <EventDataDetail/>)
                    }
                </ThemeProvider>
            </div>
        );
    }
}

export default Data;